<div
  class="container-fluid position-relative overflow-hidden p-0 h-100 d-flex justify-content-center align-items-center bg-login"
  style="padding-top: 88px;">
  <video #videoElement
         *ngIf="randomVideoUrl"
         autoplay
         loop
         muted
         playsinline
         preload="metadata"
         webkit-playsinline>
    <source [src]="randomVideoUrl"
            type="video/mp4">
  </video>
  <div class="col-12 d-flex flex-column align-items-center justify-content-center logo-box-mobile d-lg-none">
    <div
      [ngStyle]="{ 'background': Config.domain?.Details?.LogoBackgroundColor || '','opacity': Config.domain?.Details?.LogoBackgroundOpacity || 1 }"
      style="padding: 8px;">
      <img [src]="formatImage('', Config.domain?.Details?.LogoText)"
           alt="domain-logo"
           style="width: 150px;height: 140px">
    </div>
  </div>
  <div class="card-login">
    <div class="d-lg-flex flex-column align-items-center justify-content-center logo-box d-none">
      <div
        [ngStyle]="{ 'background': Config.domain?.Details?.LogoBackgroundColor || '','opacity': Config.domain?.Details?.LogoBackgroundOpacity || 1 }"
        style="padding: 8px;">
        <img [src]="formatImage('', Config.domain?.Details?.LogoText)"
             style="width: 150px;height: 140px">
      </div>
    </div>
    @if (passwordMode === true) {
      @if (otpMode === true) {
        <div class="col-12">
          <label>{{ 'EnterCodeToLogin' | translate }}</label>
          <app-otp (codeChange)="onCode($event)"></app-otp>
        </div>
        <div *ngIf="!isTimerActive"
             class="d-flex align-items-center justify-content-center mt-3">
          <span class="forget-txt ml-5">دریافت مجدد کد از طریق</span>
          <p (click)="!isTimerActive && onGetVerifyCode(true)"
             class="fz-14"
             style="margin-right: 6px">پیامک
          </p>
        </div>
        <div *ngIf="isTimerActive"
             class="d-flex align-items-center justify-content-center mt-3">
          <span class="forget-txt ml-3">{{ formatTime(timer) }}</span>
          <p class="fz-14"
             style="margin-right: 6px">مانده تا دریافت مجدد کد
          </p>
        </div>
        <div class="down-box text-center">
          <div (click)="onSignInClicked()"
               class="col-12"
               style="margin: 24px 0;">
            <app-frontend-button [disabled]="isSubmitting"
                                 [loading]="isSubmitting"
                                 [title]="'LoginToUserAccount'"
                                 class="not-padding shadow">
            </app-frontend-button>
          </div>
          <div (click)="onBackToHomeClicked()"
               class="col-12"
               style="margin: 12px 0;">
            <app-frontend-button [title]="'HomePage'"
                                 class="not-padding shadow card-secondary">
            </app-frontend-button>
          </div>
        </div>
      } @else {
        <div class="col-12">
          <label>{{ 'EnterPassword' | translate }}</label>
          <app-frontend-input (keyup.enter)="onSignInClicked()"
                              [(value)]="codeOrPassword"
                              class="input-styles"></app-frontend-input>
        </div>
        <div class="down-box">
          <div class="d-flex mb-4">
            <span (click)="onGetVerifyCode(true)"
                  class="forget-txt cursor-pointer">ورود با کد یکبارمصرف</span>
          </div>
          <!--          <div class="d-flex mt-4">-->
          <!--            <span class="forget-txt cursor-pointer">فراموشی رمز عبور ></span>-->
          <!--          </div>-->
          <div (click)="onSignInClicked()"
               class="col-12">
            <app-frontend-button [disabled]="isSubmitting"
                                 [loading]="isSubmitting"
                                 [title]="'LoginToUserAccount'"
                                 class="not-padding shadow">
            </app-frontend-button>
          </div>
          <div (click)="onBackToHomeClicked()"
               class="col-12"
               style="margin: 12px 0;">
            <app-frontend-button [title]="'HomePage'"
                                 class="not-padding shadow card-secondary">
            </app-frontend-button>
          </div>
        </div>
      }
    } @else {
      <div class="col-12">
        <label>{{ 'EnterMobile' | translate }}</label>
        <app-frontend-input (input)="onMobileInput($event)"
                            (keyup.enter)="onGetVerifyCode()"
                            [englishNumberOnly]="true"
                            [placeHolder]="'09'"
                            class="input-styles"
                            inputmode="numeric"
                            type="tel"></app-frontend-input>
      </div>
      <div class="down-box text-center">
        <div (click)="onGetVerifyCode()"
             class="col-12">
          <app-frontend-button
            [disabled]="isSubmitting"
            [loading]="isSubmitting"
            [title]="'LoginToUserAccount'"
            class="not-padding shadow">
          </app-frontend-button>
        </div>
        <div (click)="onBackToHomeClicked()"
             class="col-12"
             style="margin: 12px 0;">
          <app-frontend-button [title]="'HomePage'"
                               class="not-padding shadow card-secondary">
          </app-frontend-button>
        </div>
        <div class="d-flex flex-md-row flex-column align-items-center justify-content-center">
          <span class="forget-txt fz-10">{{ 'Role' | translate }}</span>
          <p (click)="onLicenseAgreementClicked()"
             class="fz-12">ربلان و قوانین حریم‌خصوصی است
          </p>
        </div>
      </div>
    }
  </div>
</div>
<!--<div class="container h-100 d-flex justify-content-center align-items-center" style="padding-top: 88px;">-->
<!--  <div class="col-lg-5 col-md-8 col-12 card-sign-in">-->
<!--    <div class="col-12 text-center mb-4">-->
<!--      <h1 class="m-0 p-0 fw-bold" style="color: #EE384E!important;">-->
<!--        {{ Config.domain.Title }}-->
<!--      </h1>-->
<!--    </div>-->
<!--    <span>ورود | ثبت نام</span>-->
<!--    <div class="col-12 mt-4">-->
<!--      <input [(ngModel)]="username" class="w-100" placeholder="نام کاربری" type="text"/>-->
<!--      <input [(ngModel)]="password" class="w-100" placeholder="پسورد" type="password"/>-->
<!--    </div>-->
<!--    <div class="col-12 d-flex justify-content-center" style="height: 40px;">-->
<!--      <label (click)="onLicenseAgreementClicked()">-->
<!--        ورود شما به معنای پذیرش شرایط و قوانین حریم ‌خصوصی است-->
<!--      </label>-->
<!--    </div>-->
<!--    <div class="col-12 mt-2">-->
<!--      <app-frontend-button (click)="onSignInClicked()" [title]="'ورود'" class="not-padding"></app-frontend-button>-->
<!--    </div>-->
<!--    <div class="col-12 mt-3">-->
<!--      <app-frontend-button (click)="onSignUpClicked()" [title]="'ثبت نام'" class="not-padding"></app-frontend-button>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->
